export default "__VITE_ASSET__B_Gci7ZC__"